<template>
  <div class="accountManagement">

    <!-- 查询区内容 -->
    <div class="queryArea">
      <div class="search_box">
        <el-input v-model="parameter.keyword" placeholder="请输入标题/appid" class="queryArea_input" />
        <el-select
          v-model="parameter.platformId"
          class="launch"
          filterable
          placeholder="选择平台"
        >
          <el-option
            v-for="item in platforms"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left:10px"
          @click="search"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <el-button icon="el-icon-circle-plus" type="success" @click="establish">新增图集</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%;margin-top:20px"
    >

      <!-- <el-table-column
        prop="title"
        label="标题"
        width="200"
        align="center"
      /> -->
      <el-table-column
        prop="title"
        label="标题"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="标题"
            trigger="hover"
            :content="scope.row.title"
          >
            <p slot="reference" class="titip">{{ scope.row.title }}</p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="bookName"
        label="书名"
        align="center"
      />
      <el-table-column
        prop="bookUrl"
        label="书籍链接"
        align="center"
      >
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="书籍链接"
            trigger="hover"
            :content="scope.row.bookUrl"
          >
            <p slot="reference" class="titip">{{ scope.row.bookUrl }}</p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="appId"
        label="appid"
        align="center"
      />
      <el-table-column
        prop="platName"
        label="平台"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        align="center"
      />
      <el-table-column
        prop="createdAtText"
        label="创建时间"
        align="center"
      />
      <el-table-column
        label="图片"
        align="center"
      >
        <template slot-scope="scope">
          <img style="width:50px;height:50px" :src="scope.row.coverImgPath" alt="">
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="300"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <div class="btn-wrap-box">
            <el-button type="warning" size="mini" @click="edit(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="deleteall(scope.row.id)">删除</el-button>
            <el-button type="primary" size="mini" @click="addsubset(scope.row)">增加子集</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="新增图集"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <atlisdialog ref="atewaasr" @close="close" />
    </el-dialog>
  </div>
</template>

<script>
import atlisdialog from './components/atlisdialog.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { strategyPlatform, atlaslist, deletecover } from '@/api/sourceMaterial.js'
export default {
  components: {
    atlisdialog,
    PaginationRight
  },
  data() {
    return {
      parameter: {
        keyword: null,
        platformId: null,
        page: 1,
        pageSize: 10
      },
      platforms: [], // 平台数据的
      tableData: [], // 列表数据
      dialogVisible: false, // 新增图集弹窗
      total: null// 总页数
    }
  },
  watch: {

  },
  created() {
    this.strategylist()
    this.getweatlas()
  },
  mounted() {

  },
  methods: {
    // 获取策略列表
    async strategylist() {
      const data = await strategyPlatform()
      this.platforms = data.data.list
      console.log('data', data)
    },
    // 获取图集列表
    async getweatlas() {
      const data = await atlaslist(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data列表', data)
    },
    // 分页
    fetchPageSize(e) {
      this.parameter.pageSize = e
      this.getweatlas()
    },
    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getweatlas()
    },
    // 新增
    establish() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.atewaasr.send(1)
      })
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.atewaasr.send(2, item)
      })
    },
    // 新增关闭完的回调
    close() {
      this.dialogVisible = false
      this.getweatlas()
    },
    // 删除
    deleteall(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        deletecover({
          id: id
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getweatlas()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    // 新增子集
    addsubset(item) {
      console.log('item', item)
      this.$router.push({ path: '/addsubset/index', query: { appId: item.appId, id: item.id, platformId: item.platformId }})
    },
    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.parameter.keyword = null
      this.parameter.platformId = null
      this.getweatlas()
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.getweatlas()
    }
  }
}
</script>
<style scoped>
.accountManagement{
   padding: 30px 60px;
}

.queryArea_input{
  width: 200px;
  margin-right: 10px;
}
.titip{
    width: 152px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}
.queryArea{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
